(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
  var FF=window.FF||{routes:{}};

  /* mega menu */
  var hdr=$('[data-header]');
  function closeMega(){$$('.mega.is-open').forEach(function(m){m.classList.remove('is-open')});$$('[data-mega]').forEach(function(b){b.setAttribute('aria-expanded','false')})}
  function openMega(id){closeMega();var m=document.getElementById('mega-'+id),b=$('[data-mega="'+id+'"]');if(m){m.classList.add('is-open');b&&b.setAttribute('aria-expanded','true')}}
  $$('[data-mega]').forEach(function(b){
    var id=b.getAttribute('data-mega');
    b.addEventListener('mouseenter',function(){openMega(id)});
    b.addEventListener('click',function(e){e.preventDefault();b.getAttribute('aria-expanded')==='true'?closeMega():openMega(id)});
  });
  $$('.hdr__nav>a').forEach(function(a){a.addEventListener('mouseenter',closeMega)});
  $$('.mega__dim').forEach(function(d){d.addEventListener('mouseenter',closeMega);d.addEventListener('click',closeMega)});
  hdr&&hdr.addEventListener('mouseleave',closeMega);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMega();closeDrawer()}});

  /* mobile nav */
  var burger=$('[data-burger]'),mnav=$('[data-mnav]');
  burger&&burger.addEventListener('click',function(){var o=mnav.classList.toggle('is-open');burger.setAttribute('aria-expanded',o);$('[data-burger-icon]').setAttribute('d',o?'M5 5l14 14M19 5L5 19':'M3 7h18M3 12h18M3 17h18')});

  /* cart drawer */
  function drawer(){return $('[data-drawer]')}
  function openDrawer(){var d=drawer();if(!d)return;d.classList.add('is-open');document.body.classList.add('no-scroll');closeMega()}
  function closeDrawer(){var d=drawer();if(!d)return;d.classList.remove('is-open');document.body.classList.remove('no-scroll')}
  function swapDrawer(html,open){
    if(!html)return;var tmp=document.createElement('div');tmp.innerHTML=html;var n=$('[data-drawer]',tmp),o=drawer();
    if(n&&o){o.parentNode.replaceChild(n,o);if(open)openDrawer();var c=n.getAttribute('data-count');$$('[data-cart-count]').forEach(function(el){el.textContent=c})}
  }
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-cart-open]');if(t){e.preventDefault();openDrawer();return}
    if(e.target.closest('[data-cart-close]')){e.preventDefault();closeDrawer();return}
    var r=e.target.closest('[data-line-remove]');
    if(r){e.preventDefault();fetch(FF.routes.cartChange+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:r.getAttribute('data-line-remove'),quantity:0,sections:'cart-drawer'})})
      .then(function(x){return x.json()}).then(function(j){swapDrawer(j.sections&&j.sections['cart-drawer'],true);if(document.body.classList.contains('template-cart'))location.reload()});return}
    var ap=e.target.closest('[data-apply-discount]');
    if(ap){e.preventDefault();var ci=$('[data-discount]');var code=ci&&ci.value.trim();if(!code)return;
      fetch('/discount/'+encodeURIComponent(code)+'?redirect=/cart').then(function(){return fetch('/?sections=cart-drawer')}).then(function(r){return r.json()}).then(function(j){swapDrawer(j['cart-drawer'],true)});return}
    var co=e.target.closest('[data-checkout]');
    if(co){var inp=$('[data-discount]');if(inp&&inp.value.trim()){e.preventDefault();location.href='/checkout?discount='+encodeURIComponent(inp.value.trim())}}
  });
  document.addEventListener('submit',function(e){
    var f=e.target.closest('[data-product-form]');if(!f)return;
    e.preventDefault();var btn=$('[type="submit"]',f),err=$('[data-form-error]',f);
    if(btn){btn.disabled=true;btn.setAttribute('aria-busy','true')}
    var fd=new FormData(f);fd.append('sections','cart-drawer');
    fetch(FF.routes.cartAdd+'.js',{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(x){return x.json()}).then(function(j){
        if(j.status){if(err){err.textContent=j.description||j.message;err.hidden=false}if(btn)btn.disabled=false;return}
        swapDrawer(j.sections&&j.sections['cart-drawer'],true);
        if(btn){btn.removeAttribute('aria-busy');if(f.hasAttribute('data-unique')){btn.textContent=btn.getAttribute('data-in-bag')||'In your bag'}else btn.disabled=false}
      }).catch(function(){if(btn)btn.disabled=false});
  });

  /* gallery */
  $$('[data-gallery]').forEach(function(g){
    var main=$('[data-gallery-main]',g);
    $$('[data-thumb]',g).forEach(function(b){b.addEventListener('click',function(){
      main.src=b.getAttribute('data-src');main.srcset=b.getAttribute('data-srcset')||'';main.alt=b.getAttribute('data-alt')||'';
      $$('[data-thumb]',g).forEach(function(x){x.setAttribute('aria-current',x===b)});
    })});
  });

  /* rails */
  $$('[data-rail-wrap]').forEach(function(w){
    var r=$('[data-rail]',w),bar=$('[data-rail-bar]',w);if(!r)return;
    function upd(){var m=r.scrollWidth-r.clientWidth;if(bar)bar.style.marginLeft=(m>0?r.scrollLeft/m*55:0)+'%'}
    r.addEventListener('scroll',upd,{passive:true});
    var p=$('[data-rail-prev]',w),n=$('[data-rail-next]',w);
    p&&p.addEventListener('click',function(){r.scrollBy({left:-340,behavior:'smooth'})});
    n&&n.addEventListener('click',function(){r.scrollBy({left:340,behavior:'smooth'})});
  });

  /* sticky offset under header */
  function hdrH(){var h=$('[data-header]');if(h)document.documentElement.style.setProperty('--hdr-h',h.offsetHeight+'px')}
  hdrH();window.addEventListener('resize',hdrH);

  /* collection filter drawer + sort (AJAX via section rendering) */
  $$('[data-coll]').forEach(function(root){
    var sid=root.getAttribute('data-section'),base=root.getAttribute('data-url'),timer,ctrl;
    var drawer=$('[data-filter-drawer]',root),form=$('[data-filter-form]',root),opener=$('[data-filter-open]',root);
    function openF(){if(!drawer)return;drawer.classList.add('is-open');document.body.classList.add('no-scroll');opener&&opener.setAttribute('aria-expanded','true');var c=$('[data-filter-close].icon-btn',drawer);c&&c.focus()}
    function closeF(){if(!drawer)return;drawer.classList.remove('is-open');document.body.classList.remove('no-scroll');opener&&opener.setAttribute('aria-expanded','false');opener&&opener.focus()}
    function qsFromForm(){var q=new URLSearchParams();if(form){new FormData(form).forEach(function(v,k){if(String(v).trim()!=='')q.append(k,v)})}else{var s=new URLSearchParams(location.search).get('sort_by');if(s)q.set('sort_by',s)}return q.toString()}
    function swap(sel,from){var a=$$(sel,root),b=$$(sel,from);a.forEach(function(el,i){if(b[i])el.innerHTML=b[i].innerHTML})}
    function load(qs){
      if(ctrl&&ctrl.abort)ctrl.abort();ctrl=window.AbortController?new AbortController():null;
      root.classList.add('is-loading');
      fetch(base+'?'+(qs?qs+'&':'')+'section_id='+sid,ctrl?{signal:ctrl.signal}:{}).then(function(r){return r.text()}).then(function(html){
        var tmp=document.createElement('div');tmp.innerHTML=html;var n=$('[data-coll]',tmp)||tmp;
        var openSet={};$$('.facet',root).forEach(function(d){openSet[d.getAttribute('data-facet')]=d.open});
        var body=$('[data-fbody]',root),st=body?body.scrollTop:0;
        swap('[data-results]',n);swap('[data-active]',n);swap('[data-coll-count]',n);swap('[data-fcount]',n);swap('[data-sort-label]',n);swap('[data-apply-label]',n);swap('[data-ctabs]',n);swap('[data-fbody]',n);
        $$('.facet',root).forEach(function(d){var k=d.getAttribute('data-facet');if(k in openSet)d.open=openSet[k]});
        if(body)body.scrollTop=st;
        $$('[data-sort]',root).forEach(function(b){var cur=new URLSearchParams(qs).get('sort_by');b.setAttribute('aria-selected',String(b.getAttribute('data-sort')===cur))});
        history.replaceState(null,'',base+(qs?'?'+qs:''));
        root.classList.remove('is-loading');
      }).catch(function(e){if(e&&e.name==='AbortError')return;location.href=base+(qs?'?'+qs:'')});
    }
    root.addEventListener('click',function(e){
      if(e.target.closest('[data-filter-open]')){e.preventDefault();openF();return}
      if(e.target.closest('[data-filter-close]')){e.preventDefault();closeF();return}
      var so=e.target.closest('[data-sort]');
      if(so){e.preventDefault();var si=$('[data-sort-input]',root);if(si)si.value=so.getAttribute('data-sort');var q=new URLSearchParams(qsFromForm());q.set('sort_by',so.getAttribute('data-sort'));var m=so.closest('details');if(m)m.open=false;load(q.toString());return}
      var cl=e.target.closest('[data-filter-clear]');
      if(cl){e.preventDefault();if(form)$$('input[type="checkbox"]',form).forEach(function(c){c.checked=false}),$$('input[type="number"]',form).forEach(function(c){c.value=''});load(qsFromForm());return}
      var pa=e.target.closest('[data-active] a,[data-ctabs] a');
      if(pa){e.preventDefault();var u=new URL(pa.href,location.href);u.searchParams.delete('section_id');load(u.searchParams.toString());return}
    });
    if(form){
      form.addEventListener('change',function(e){if(e.target.type==='number')return;clearTimeout(timer);timer=setTimeout(function(){load(qsFromForm())},120)});
      form.addEventListener('input',function(e){if(e.target.type!=='number')return;clearTimeout(timer);timer=setTimeout(function(){load(qsFromForm())},500)});
      form.addEventListener('submit',function(e){e.preventDefault();clearTimeout(timer);load(qsFromForm());closeF()});
    }
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer&&drawer.classList.contains('is-open'))closeF()});
    document.addEventListener('click',function(e){var m=$('[data-sortmenu]',root);if(m&&m.open&&!m.contains(e.target))m.open=false});
  });

  /* recommendations */
  $$('[data-recs]').forEach(function(el){
    fetch(el.getAttribute('data-url')).then(function(r){return r.text()}).then(function(t){
      var tmp=document.createElement('div');tmp.innerHTML=t;var inner=$('[data-recs]',tmp);if(inner&&inner.innerHTML.trim())el.innerHTML=inner.innerHTML;
    });
  });

  /* booking */
  $$('[data-booking]').forEach(function(root){
    var sp=function(s,d){var a=(s||'').split(',').map(function(x){return x.trim()}).filter(Boolean);return a.length?a:d};
    var DOW=sp(root.getAttribute('data-dow'),['Sun','Mon','Tue','Wed','Thu','Fri','Sat']),MON=sp(root.getAttribute('data-mon'),['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']);
    var days=(root.getAttribute('data-days')||'3,6').split(',').filter(Boolean).map(Number),ahead=+root.getAttribute('data-ahead')||8;
    var slots=(root.getAttribute('data-slots')||'').split(',').map(function(s){return s.trim()}).filter(Boolean);
    var datesEl=$('[data-dates]',root),slotsEl=$('[data-slots]',root),hint=$('[data-slot-hint]',root);
    var inDate=$('[name="contact[Appointment date]"]',root),inTime=$('[name="contact[Appointment time]"]',root),btn=$('[data-book-submit]',root);
    var sumDate=$$('[data-sum-date]'),sumTime=$$('[data-sum-time]'),sumParty=$$('[data-sum-party]');
    var t=new Date();t.setHours(0,0,0,0);var list=[];
    for(var i=1;list.length<ahead&&i<120;i++){var d=new Date(t);d.setDate(t.getDate()+i);if(days.indexOf(d.getDay())>-1)list.push(d)}
    function fmt(d){return DOW[d.getDay()]+' '+d.getDate()+' '+MON[d.getMonth()]+' '+d.getFullYear()}
    function check(){var ok=inDate.value&&inTime.value;$$('[required]',root).forEach(function(x){if(!x.value.trim())ok=false});btn.disabled=!ok}
    list.forEach(function(d){
      var b=document.createElement('button');b.type='button';b.className='date';
      b.innerHTML='<span class="label" style="font-size:10px">'+DOW[d.getDay()]+'</span><b>'+d.getDate()+'</b><span class="mono" style="font-size:10px">'+MON[d.getMonth()]+'</span>';
      b.addEventListener('click',function(){
        $$('.date',datesEl).forEach(function(x){x.classList.remove('is-on')});b.classList.add('is-on');
        inDate.value=fmt(d);inTime.value='';sumDate.forEach(function(s){s.textContent=fmt(d)});sumTime.forEach(function(s){s.textContent='Not selected'});
        slotsEl.innerHTML='';hint.hidden=true;
        slots.forEach(function(s){var c=document.createElement('button');c.type='button';c.className='chip';c.textContent=s;
          c.addEventListener('click',function(){$$('.chip',slotsEl).forEach(function(x){x.classList.remove('is-on')});c.classList.add('is-on');inTime.value=s;sumTime.forEach(function(x){x.textContent=s});check()});
          slotsEl.appendChild(c)});
        check();
      });
      datesEl.appendChild(b);
    });
    $$('[name="contact[Guests]"]',root).forEach(function(r){r.addEventListener('change',function(){sumParty.forEach(function(s){s.textContent=r.value})})});
    $$('input,textarea',root).forEach(function(x){x.addEventListener('input',check)});
    check();
  });

  /* simple required-field gating for forms with data-gate */
  $$('form[data-gate]').forEach(function(f){
    var b=$('[type="submit"]',f);function c(){var ok=true;$$('[required]',f).forEach(function(x){if(!x.value.trim())ok=false});b.disabled=!ok}
    $$('input,textarea,select',f).forEach(function(x){x.addEventListener('input',c)});c();
  });
})();